import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CreateDashboardViewRPC } from "./createDashboardViewRPC";

export class CreateDashboardViewRPCClientImpl extends CreateDashboardViewRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CreateDashboardViewRPC.Request): Promise<LeoRPCResult<CreateDashboardViewRPC.Response, CreateDashboardViewRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/CreateDashboardView",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CreateDashboardViewRPC.ResponseDTO,
      CreateDashboardViewRPC.Errors.ErrorsDTO,
      CreateDashboardViewRPC.Response,
      CreateDashboardViewRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/CreateDashboardView",
      CreateDashboardViewRPC.Response.fromDTO,
      CreateDashboardViewRPC.Errors.fromDTO
    );
  }
}
